import { CollectionTranslationsRepository } from '@lib/api/repository/collection-translations';
import {
  TRANSLATION_STATE,
  TranslationJob,
  TranslationJobInput,
} from '@lib/types/collection-translations';

import { Requester } from '../clients';

interface RowDTO {
  cardId: string;
  code: string;
  namePt?: string;
  nameEn?: string;
  descriptionPt?: string;
  descriptionEn?: string;
  archetype?: string;
  translated: boolean;
  failed: boolean;
}

interface JobDTO {
  id: string;
  collectionId: string;
  state: string;
  total: number;
  completed: number;
  translated: number;
  translatedPercentage: number;
  missingPercentage: number;
  rows: RowDTO[];
}

const path = (collectionId: string) =>
  `/marketplace/admin/catalog/collections/${collectionId}/translations`;

const toJob = (data: JobDTO): TranslationJob => ({
  id: data.id,
  collectionId: data.collectionId,
  state:
    Object.values(TRANSLATION_STATE).find((state) => state === data.state) ??
    TRANSLATION_STATE.FAILED,
  total: data.total,
  completed: data.completed,
  translated: data.translated,
  translatedPercentage: data.translatedPercentage,
  missingPercentage: data.missingPercentage,
  rows: data.rows.map((row) => ({
    cardId: row.cardId,
    code: row.code,
    namePt: row.namePt,
    nameEn: row.nameEn,
    descriptionPt: row.descriptionPt,
    descriptionEn: row.descriptionEn,
    archetype: row.archetype,
    translated: row.translated,
    failed: row.failed,
  })),
});

export default class CollectionTranslationsAPI implements CollectionTranslationsRepository {
  async start(collectionId: string) {
    const { data } = await Requester.post<JobDTO>(path(collectionId));
    return toJob(data);
  }

  async find(input: TranslationJobInput, signal?: AbortSignal) {
    const { data } = await Requester.get<JobDTO>(
      `${path(input.collectionId)}/${input.jobId}`,
      { signal },
    );

    return toJob(data);
  }

  async save(input: TranslationJobInput) {
    const { data } = await Requester.post<JobDTO>(
      `${path(input.collectionId)}/${input.jobId}/save`,
    );

    return toJob(data);
  }
}
